import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { useDistribution } from './useDistribution';
import { Distribution } from './Distribution';
import { usePageTitle } from '../pageTitleContext/PageTitleContext';

export const DistributionContainer: FC = observer(() => {

  const distributionResult = useDistribution();
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    const title = [distributionResult.distribution
      ? distributionResult.distribution.id.toString() : '', 'Distribution'];
    setPageTitle(title);
  });

  return distributionResult.isLoaded && distributionResult.distribution != null
    ? <Distribution title={`Distribution ${distributionResult.distribution.id}`}
                    distribution={distributionResult.distribution} />
    : <CustomSpinner spinnerText={'Loading distribution...'} />;

});
